const weekdays = ['1', '2', '3', '4', '5'];
const weekends = ['0', '6'];

export const returnDayOfWeek = (days) => {
    if (!Array.isArray(days)) {
        return 'Invalid Input';
    };
    
    if (days.length === 0) {
        return '';
    };
    
    if (days.length === 7) {
        return 'Every Day';
    };
    
    if (weekends.every(d => days.includes(d))) {
        days = days.filter(d => weekdays.includes(d));
        days.unshift('Weekends');
    } else if (weekdays.every(d => days.includes(d))) {
        days = days.filter(d => weekends.includes(d));
        days.unshift('Weekdays');
    };

    return days.map(dayNum => mapDayNumToLabel(dayNum)).join(', ');
};

const mapDayNumToLabel = (dayNum) => {
    if (dayNum === 'Weekdays' || dayNum === 'Weekends') {
        return dayNum;
    };

    const days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
    return days[Number(dayNum)] || 'Invalid Day';
};
